import { getDefaultConfig } from "@/fit-components/loading/business";


export default {
    loading: getDefaultConfig(),
};
